import React from 'react';
import Modal from '../../shared/components/core-ui/modal/modal.component';
import { SECTION_TITLE } from './hr.util';

/** The dialog frame every HR form uses: the same Modal settings as the finance request dialogs. */
export const HrDialog: React.FC<{
  title: string;
  onClose: () => void;
  footer: React.ReactNode;
  children: React.ReactNode;
}> = ({ title, onClose, footer, children }) => (
  <Modal
    config={{
      showModal: true,
      fullScreen: false,
      showClose: true,
      maxWidth: 'sm',
      paperClassName: '!rounded-[16px]',
      contentClassName: '!min-h-0 !h-auto !pt-[28px] px-[20px] sm:px-[28px] pb-[28px]'
    }}
    eventHandlers={{ closeModalHandler: onClose }}
  >
    <div className="flex flex-col gap-[20px] font-gilroy-regular text-neutral-500">
      <h2 className={`${SECTION_TITLE} !mb-0 pr-[48px]`}>{title}</h2>
      {children}
      <div className="flex flex-wrap justify-end gap-[6px]">{footer}</div>
    </div>
  </Modal>
);
